import type { SVGProps } from "react";
const SvgGoogle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#4285F4"
      d="M12 9.818v4.648h6.458c-.284 1.494-1.135 2.76-2.411 3.61l3.895 3.022c2.269-2.094 3.578-5.17 3.578-8.825 0-.85-.077-1.67-.218-2.455z"
    />
    <path
      fill="#34A853"
      d="m5.275 14.284-.879.673-3.109 2.421C3.262 21.295 7.31 24 12 24c3.24 0 5.957-1.069 7.942-2.902l-3.894-3.021c-1.07.72-2.433 1.156-4.048 1.156-3.12 0-5.77-2.105-6.72-4.942z"
    />
    <path
      fill="#FBBC05"
      d="M1.287 6.622A11.85 11.85 0 0 0 0 12c0 1.942.469 3.764 1.287 5.378 0 .011 3.993-3.098 3.993-3.098A7.2 7.2 0 0 1 4.898 12c0-.796.142-1.56.382-2.28z"
    />
    <path
      fill="#EA4335"
      d="M12 4.778c1.767 0 3.338.611 4.593 1.79l3.436-3.437C17.945 1.189 15.239 0 11.999 0 7.31 0 3.263 2.695 1.288 6.622L5.28 9.72c.949-2.836 3.6-4.942 6.72-4.942"
    />
  </svg>
);
export default SvgGoogle;